import React from 'react';
import { connect } from '@gasbuddy/react';
import ResetPasswordForm from './reset-password-form';
import sharedStyle from '../../styles/shared.css';
import LoggedOutLayout from '../../components/logged-out-layout';
import FormMessage from '../../components/form-message';

/* eslint-disable react/prefer-stateless-function */
class ResetPassword extends React.Component {
  render() {
    return (
      <LoggedOutLayout>
        <div className={sharedStyle.textCenter}>
          <FormMessage
            title="Reset Your Password"
            subTitle="Passwords must be at six characters long, and must include at least one uppercase character and at least one numeral."
          />
        </div>
        <ResetPasswordForm />
      </LoggedOutLayout>
    );
  }
}

export default connect()(ResetPassword);
